enum TimeRoundingType {
  NEAREST = 10,
  ROUND_DOWN = 20,
  ROUND_UP = 30,
  EMPLOYEE_FAVORABLE = 40,
}

export default TimeRoundingType;
